class Controller {
}
Controller.depends = [];
export default Controller;
